import {debounce} from 'lodash-es';
import {
    AgGrid,
    AgGridColumnMenuTrigger,
    AgGridExportMenu,
    AgGridProvider,
    AgGridTimestamp,
    AgGridToggleShowFilters,
    NyDateTimeInput,
    NySelectInput
} from 'nyse-web-tools-common/lib/react';
import connect from 'nyse-web-tools-common/lib/utils/redux.connect';
import React from 'react';

import {NavigationSectionMenu} from '../components/navigation/navigation.section.menu';
import {FirmSelect} from '../components/selects/firm.select';
import {FirmParticipantSelect} from '../components/selects/firmParticipant.select';
import {setColumns} from '../stores/columnDefs/columnDefs.actions';
import {getMyVolumesFilters} from '../stores/myVolumes/myVolumesFilters.actions';
import {getMyVolumesTradeCount} from '../stores/myVolumes/myVolumesTradeCount.actions';

@connect(
    [
        'firms',
        'columnDefs',
        'myVolumesTradeCount',
        'myVolumesFilters',
        'platform',
        'route'
    ],
    {
        getMyVolumesFilters,
        getMyVolumesTradeCount,
        setColumns
    }
)
export class MyVolumesTradeCountPage extends React.Component {
    state = {
        filterValues: {},
        views: [
            {
                title: 'CADV',
                url: '/:platform/volumes/cadv'
            },
            {
                title: 'Broker Rank',
                url: '/:platform/volumes/broker-rank'
            },
            {
                title: 'Trade Count',
                url: '/:platform/volumes/trade-count'
            },
            {
                title: 'Search',
                url: '/:platform/volumes/search'
            }
        ]
    };

    _initialFilters = {
        brokerBadge: '',
        crd: this.props.route.params.crd || (this.props.firms[0] || {}).crd,
        date: '',
        mmId: '',
        participantId: '',
        sessionId: '',
        mpSubId: ''
    };

    _getMyVolumesFilters = debounce(this.props.getMyVolumesFilters, 500);

    componentWillUnmount() {
        this._getMyVolumesFilters.cancel();
    }

    componentDidUpdate(prevProps, prevState) {
        const hasCrdChanged =
            prevState.filterValues.crd !== this.state.filterValues.crd;
        const hasMpidChanged =
            prevState.filterValues.participantId !==
            this.state.filterValues.participantId;
        const hasDateChanged =
            (prevState.filterValues.date || '').toString() !==
            (this.state.filterValues.date || '').toString();

        if (hasCrdChanged || hasMpidChanged || hasDateChanged) {
            this._getMyVolumesFilters(this.state.filterValues);
        }
    }

    _onDateChange = ({setValue}) => {
        setValue('brokerBadge', '');
        setValue('mmId', '');
        setValue('sessionId', '');
        setValue('mpSubId', '');
    };

    _onFiltersChanged = (filterValues) => {
        this.setState({
            filterValues
        });
    };

    _onFirmChange = ({setValue}) => {
        setValue('brokerBadge', '');
        setValue('mmId', '');
        setValue('participantId', '');
        setValue('sessionId', '');
        setValue('mpSubId', '');
    };

    render() {
        const {brokerBadges, mmIds, sessionIds, mpSubIds} = this.props.myVolumesFilters;

        return (
            <>
                <div className='row'>
                    <div className='col-md-12 col-lg-12 col-xl-12 col-sm-12 col-xs-12'>
                        <NavigationSectionMenu
                            queryParams={this.state.filterValues}
                            views={this.state.views}
                        />
                    </div>
                </div>
                <AgGridProvider
                    columnDefs={this.props.columnDefs.myVolumesTradeCount}
                    columnNamespace='myVolumesTradeCount'
                    filtersClassName='row space-bottom-1'
                    initialFilters={this._initialFilters}
                    onColumnsChanged={this.props.setColumns}
                    onFiltersChanged={this._onFiltersChanged}
                    onLoad={this.props.getMyVolumesTradeCount}
                    submitOnLoad
                    {...this.props.myVolumesTradeCount}>
                    <AgGridProvider.Filters>
                        <div className='form-group col-xl-2 col-lg-2 col-md-2 col-sm-3 col-xs-12'>
                            <label>Date</label>
                            <NyDateTimeInput
                                className='form-control'
                                format='MM/yyyy'
                                initialValue={this.props.route.params.date}
                                minView='months'
                                name='date'
                                onChange={this._onDateChange}
                            />
                        </div>
                        {this.props.firms.length > 1 && (
                            <div className='form-group col-xl-2 col-lg-2 col-md-2 col-md-2 col-sm-3 col-xs-12'>
                                <label>Firm</label>
                                <FirmSelect
                                    name='crd'
                                    onChange={this._onFirmChange}
                                    required={true}
                                />
                            </div>
                        )}
                        <div className='form-group col-xl-2 col-lg-2 col-md-2 col-md-2 col-sm-3 col-xs-12'>
                            <label>ETPID / MPID</label>
                            <FirmParticipantSelect
                                crd={this.state.filterValues.crd}
                                initialValue={
                                    this.props.route.params.participantId
                                }
                                name='participantId'
                            />
                        </div>
                        <div className='form-group col-xl-2 col-lg-2 col-md-2 col-md-2 col-sm-3 col-xs-12'>
                            <label>Session Id</label>
                            <NySelectInput
                                initialValue={this.props.route.params.sessionId}
                                name='sessionId'
                                disabled={sessionIds.length === 0}>
                                <option value=''>-</option>
                                {sessionIds.map((sessionId) => (
                                    <option key={sessionId} value={sessionId}>
                                        {sessionId}
                                    </option>
                                ))}
                            </NySelectInput>
                        </div>
                        <div className='form-group col-xl-2 col-lg-2 col-md-2 col-md-2 col-sm-3 col-xs-12'>
                            <label>Broker Badge</label>
                            <NySelectInput
                                initialValue={
                                    this.props.route.params.brokerBadge
                                }
                                name='brokerBadge'
                                disabled={brokerBadges.length === 0}>
                                <option value=''>-</option>
                                {brokerBadges.map((brokerBadge) => (
                                    <option
                                        key={brokerBadge}
                                        value={brokerBadge}>
                                        {brokerBadge}
                                    </option>
                                ))}
                            </NySelectInput>
                        </div>
                        <div className='form-group col-xl-2 col-lg-2 col-md-2 col-md-2 col-sm-3 col-xs-12'>
                            <label>MMID</label>
                            <NySelectInput
                                initialValue={this.props.route.params.mmId}
                                name='mmId'
                                disabled={mmIds.length === 0}>
                                <option value=''>-</option>
                                {mmIds.map((mmId) => (
                                    <option key={mmId} value={mmId}>
                                        {mmId}
                                    </option>
                                ))}
                            </NySelectInput>
                        </div>
                        <div className='form-group col-lg-2 col-md-2 col-md-2 col-sm-3 col-xs-12'>
                            <label>Mnemonic</label>
                            <NySelectInput
                                initialValue={this.props.route.params.mpSubId}
                                name='mpSubId'
                                disabled={mpSubIds.length === 0}>
                                <option value=''>-</option>
                                {mpSubIds.map((mpSubId) => (
                                    <option key={mpSubId} value={mpSubId}>
                                        {mpSubId}
                                    </option>
                                ))}
                            </NySelectInput>
                        </div>
                    </AgGridProvider.Filters>

                    <div className='row space-bottom-1'>
                        <div className='col-md-12 col-lg-12 col-xl-12 col-sm-12 col-xs-12'>
                            <div className='flex-row flex-align-bottom'>
                                <AgGridProvider.SubmitBtn>
                                    Search
                                </AgGridProvider.SubmitBtn>
                                <AgGridProvider.ResetBtn>
                                    Reset
                                </AgGridProvider.ResetBtn>
                                <div className='btn-circle-grp flex-pull-right'>
                                    <AgGridToggleShowFilters />
                                    <AgGridExportMenu
                                        customHeader={
                                            this.props.myVolumesTradeCount
                                                .timestamp
                                        }
                                        exportFileName='myVolumesTradeCount'
                                        exportSheetName={
                                            this.props.platform.name
                                        }
                                    />
                                    <AgGridColumnMenuTrigger />
                                </div>
                            </div>
                        </div>
                    </div>

                    <AgGrid reactNext={true} treeData={true} />

                    <div className='row space-top-1'>
                        <div className='col-md-12 col-lg-12 col-xl-12 col-sm-12 col-xs-12'>
                            <AgGridTimestamp timestampPrefix='Volumes' />
                        </div>
                    </div>

                    <div className='disclaimer space-top-1'>
                        This information is provided 'as is', and NYSE, NYSE
                        Arca, NYSE American, NYSE Arca Options, NYSE American
                        Options and their respective affiliates do not warrant
                        the accuracy, adequacy, timeliness or completeness of
                        this information. The information, which excludes any
                        data from the current trading day, is intended to be
                        used for informational purposes only and will not be
                        used to determine qualification for any rebates or
                        incentives.
                    </div>
                </AgGridProvider>
            </>
        );
    }
}
